var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CE49F00-FDB5-4B1F-9D8B-55798827C92D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client-|-Health-System-Level---Month-Date-range",
    transform: "translate(-1543.000000, -131.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(1543.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,12 L8,10 L10,10 L10,12 L8,12 Z M4,12 L4,10 L6,10 L6,12 L4,12 Z M12,12 L12,10 L14,10 L14,12 L12,12 Z M8,16 L8,14 L10,14 L10,16 L8,16 Z M4,16 L4,14 L6,14 L6,16 L4,16 Z M12,16 L12,14 L14,14 L14,16 L12,16 Z M0,20 L0,1.5 L3.125,1.5 L3.125,0 L4.75,0 L4.75,1.5 L13.25,1.5 L13.25,0 L14.875,0 L14.875,1.5 L18,1.5 L18,20 L0,20 Z M1.5,18.5 L16.5,18.5 L16.5,7.75 L1.5,7.75 L1.5,18.5 Z M1.5,6.25 L16.5,6.25 L16.5,3 L1.5,3 L1.5,6.25 Z M1.5,6.25 L1.5,3 L1.5,6.25 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.dc683b0b20c5b50d117223b7e20d6411.svg";
export { ForwardRef as ReactComponent };